<template>
  <div id="app">
    <header>
      <nav role="navigation">
        <div class="visible-navbar">
          <div class="spacer empty"></div>
          <div class="spacer logo-container">
            <router-link to="/"><img src="@/assets/branton-logo.svg" alt="Branton Advertising"/></router-link>
          </div>
          <div class="spacer right-side">
            <div class="social-media-nav">
              <ul>
                <!-- <li><a :href="'/'"><img src="@/assets/instagram.svg" alt="Branton - Instagram"></a></li> -->
                <li>
                  <a target="_blank" :href="'https://twitter.com/BrantonAd'"><img src="@/assets/twitter.svg" alt="Branton - Twitter"/></a>
                </li>
                <li>
                  <a target="_blank" :href="'https://www.linkedin.com/company/branton'"><img src="@/assets/linkedin-logo.svg" alt="Branton - LinkedIn"/></a>
                </li>
                <li>
                  <a target="_blank" :href="'https://www.facebook.com/branton.ca/'"><img src="@/assets/facebook-logo.svg" alt="Branton - Facebook"/></a>
                </li>
              </ul>
            </div>
            <button @click="toggleMenu" class="nav-menu-button">
              <div></div>
              <div></div>
              <div></div>
            </button>
          </div>
        </div>
        <div class="nav-menu-content">
          <div class="nav-menu-content--list">
            <div class="list-container">
              <div class="list--nav listheight">
                <ul>
                  <li @click="navclose()" @mouseenter="hoverOn('home')" @mouseleave="hoverOn('home')">
                    <router-link to="/"
                      >Home
                      <hr :class="{ active: $route.name == 'Home Page' }" />
                    </router-link>
                  </li>
                  <!-- <li @click="navclose()" @mouseenter="hoverOn('team')" @mouseleave="hoverOn('team')">
                    <router-link to="/team">Team
                      <hr :class="{'active' : $route.name == 'Team Page'}">
                    </router-link>
                  </li> -->
                  <li @click="navclose()" @mouseenter="hoverOn('about')" @mouseleave="hoverOn('about')">
                    <router-link to="/about"
                      >Creative
                      <hr :class="{ active: $route.name == 'About Page' }" />
                    </router-link>
                  </li>
                  <li @click="navclose()" @mouseenter="hoverOn('translations')" @mouseleave="hoverOn('translations')">
                    <router-link to="/translations"
                      >Translations
                      <hr :class="{ active: $route.name == 'Translations Page' }" />
                    </router-link>
                  </li>
                  <li @click="navclose()" @mouseenter="hoverOn('work')" @mouseleave="hoverOn('work')">
                    <router-link to="/work"
                      >Work
                      <hr :class="{ active: $route.name == 'Work Page' }" />
                    </router-link>
                  </li>
                  <li @click="navclose()" @mouseenter="hoverOn('careers')" @mouseleave="hoverOn('careers')">
                    <router-link to="/careers"
                      >Careers
                      <hr :class="{ active: $route.name == 'Careers Page' }" />
                    </router-link>
                  </li>
                  <li @click="navclose()" @mouseenter="hoverOn('contact')" @mouseleave="hoverOn('contact')">
                    <router-link to="/contact"
                      >Contact
                      <hr :class="{ active: $route.name == 'Contact Page' }" />
                    </router-link>
                  </li>
                </ul>
              </div>
              <!-- <div class="list--bottom-info listheight">
                <ul class="bottom-info--contact">
                  <li>122 Chestnut Place</li>
                  <li>London, ON <span class="uh">N6K 4J6</span></li>
                  <li><a :href="'tel:5194716778'">519.471.6778</a></li>
                  <li><a :href="'mailto:info@branton.ca'">info@branton.ca</a></li>
                </ul>
                <ul class="bottom-info--social">
       
                <li><a target="_blank" :href="'https://twitter.com/BrantonAd'"><img src="@/assets/twitter.svg" alt="Branton - Twitter"></a></li>
                <li><a target="_blank" :href="'https://www.linkedin.com/company/branton'"><img src="@/assets/linkedin-logo.svg" alt="Branton - LinkedIn"></a></li>
                <li><a target="_blank" :href="'https://www.facebook.com/branton.ca/'"><img src="@/assets/facebook-logo.svg" alt="Branton - Facebook"></a></li>
                </ul>
              </div> -->
            </div>
          </div>
          <div class="nav-menu-content--image">
            <div :class="{ current: $route.name == 'Home Page' }" data-page="home"></div>
            <div :class="{ current: $route.name == 'About Page' }" data-page="about"></div>
            <div :class="{ current: $route.name == 'Translations Page' }" data-page="translations"></div>
            <!-- <div :class="{'current' : $route.name == 'Team Page'}" data-page="team"></div> -->
            <div :class="{ current: $route.name == 'Work Page' }" data-page="work"></div>
            <div :class="{ current: $route.name == 'Careers Page' }" data-page="careers"></div>
            <div :class="{ current: $route.name == 'Contact Page' }" data-page="contact"></div>
          </div>
        </div>
      </nav>
    </header>

    <b-container fluid class="wrapper">
      <main>
        <router-view></router-view>
      </main>

      <footer class="main-footer" aria-label="contentinfo">
        <div class="footer-headline">
          <h2>Explorers, creators, disruptors.</h2>
          <p>
            <router-link to="/contact" class="footer-cta">Let’s start something great together.</router-link>
          </p>
        </div>
        <div class="footer-headline">
          <ul>
            <li><a href="tel:5194716778">519.471.6778</a></li>
            <li><a href="mailto:info@branton.ca">info@branton.ca</a></li>
          </ul>
          <!-- <p>122 Chestnut Place, <br>London, &nbsp;&nbsp;Ontario  &#8203; &nbsp;&nbsp; N6K 4J6</p> -->

          <div class="social-media-nav">
            <ul>
              <!-- <li><a :href="'/'"><img src="@/assets/instagram.svg" alt="Branton - Instagram"></a></li> -->
              <li>
                <a target="_blank" :href="'https://twitter.com/BrantonAd'"><img src="@/assets/twitter.svg" alt="Branton - Twitter"/></a>
              </li>
              <li>
                <a target="_blank" :href="'https://www.linkedin.com/company/branton'"><img src="@/assets/linkedin-logo.svg" alt="Branton - LinkedIn"/></a>
              </li>
              <li>
                <a target="_blank" :href="'https://www.facebook.com/branton.ca/'"><img src="@/assets/facebook-logo.svg" alt="Branton - Facebook"/></a>
              </li>
            </ul>
          </div>
        </div>

        <div class="footer-info">
          <div class="footer-info-content">
            <ul>
              <li>
                <router-link to="/" :class="{ active: $route.name == 'Home Page' }">Home</router-link>
              </li>

              <li>
                <router-link to="/about" :class="{ active: $route.name == 'About Page' }">Creative</router-link>
              </li>
              <li>
                <router-link to="/translations" :class="{ active: $route.name == 'Translations Page' }">Translations</router-link>
              </li>

              <li>
                <router-link to="/work" :class="{ active: $route.name == 'Work Page' }">Work</router-link>
              </li>
              <li>
                <router-link to="/careers" :class="{ active: $route.name == 'Careers Page' }">Careers</router-link>
              </li>
              <li>
                <router-link to="/contact" :class="{ active: $route.name == 'Contact Page' }">Contact</router-link>
              </li>
            </ul>
            <b-row class="justify-content-center">
              <b-col col md="10">
                <p class="copyright">Branton provides full-service marketing and advertising solutions to industries across Canada and beyond. We build partnerships with our clients to deliver first-class campaigns that attract audiences and convert into sales. © Branton, 2026. All rights reserved.</p>
              </b-col>
            </b-row>
          </div>
        </div>
      </footer>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isAnimating: false,
      isHovering: false,
    };
  },
  methods: {
    debounce: function(func, wait = 20, immediate = true) {
      let timeout;
      return function executedFunction() {
        let context = this;
        let args = arguments;
        let later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
      };
    },
    hoverOn: function(name) {
      let vm = this;

      return vm.debounce(vm.menuHover(name));
    },
    menuHover: function(name) {
      let bgImage = document.querySelector('.nav-menu-content--image div[data-page="' + name + '"]');
      // let current = document.querySelector('.nav-menu-content--image .current');
      bgImage.classList.toggle("visible");

      // if(bgImage.classList.contains("visible")){
      //     current.style.opacity = "0";
      //     } else {
      //     current.style.opacity = "1";
      //     }

      return;
    },
    toggleMenu: function() {
      let vm = this;
      let menu = document.querySelector(".nav-menu-button");
      let menuContainer = document.querySelector(".nav-menu-content");
      let menuContent = document.querySelector(".nav-menu-content--list");
      // let menuBg = document.querySelector(".nav-menu-content--image");
      let menuList = document.querySelector(".list-container");
      // let header = document.querySelector('header');
      let body = document.querySelector("body");
      if (!vm.isAnimating) {
        menu.classList.remove("visible-menu-hover");
        menu.classList.toggle("visible-menu");
        menuContainer.classList.toggle("menuHidden");
        if (menu.classList.contains("visible-menu")) {
          body.classList.add("locked-body");
          menuContainer.classList.add("menuNone");
          setTimeout(function() {
            menuContent.classList.add("slide-down");
            setTimeout(function() {
              // menuBg.classList.add('slide-down');
              setTimeout(function() {
                menu.classList.add("visible-menu-hover");
                menuList.classList.add("fade-in");
                vm.isAnimating = false;
                return;
              }, 250);
            }, 250);
          }, 250);
        } else {
          setTimeout(function() {
            body.classList.remove("locked-body");
            menuList.classList.remove("fade-in");
            menuContent.classList.remove("slide-down");
            setTimeout(function() {
              // menuBg.classList.remove('slide-down');

              setTimeout(function() {
                setTimeout(function() {
                  menuContainer.classList.remove("menuNone");
                }, 440);

                vm.isAnimating = false;
                return;
              }, 250);
            }, 250);
          }, 250);
        }
      }
      vm.isAnimating = true;
      return;
    },
    navclose: function() {
      let vm = this;
      let menu = document.querySelector(".nav-menu-button");
      if (menu.classList.contains("visible-menu")) {
        return vm.toggleMenu();
      }
      return true;
    },
  },
  watch: {
    $route() {
      let vm = this;
      let menu = document.querySelector(".nav-menu-button");
      if (menu.classList.contains("visible-menu")) {
        return vm.toggleMenu();
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/global.scss";
@import "@/assets/css/header.scss";
@import "@/assets/css/footer.scss";

.uh {
  margin-left: 8px;
}
</style>
